export enum MenuPlacement {
  Main = 'main',
  Header = 'header',
}
